import { api } from "../api";
export const profileFtechApi = (params) => {
  return api.get("/api/admin/fetch-profile", JSON.stringify(params));
};
